module.exports = __webpack_public_path__ + "static/media/continuar-compra.006445f3.svg";